/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_InitializingInputs */



/**
* | output |
* | --- |
* | "Initializing OCR engine..." |
*
* @param {Ocr_InitializingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_initializing = /** @type {((inputs?: Ocr_InitializingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_InitializingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Initialisation du moteur OCR...")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Engine wird initialisiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizializzazione del motore OCR in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инициализация механизма распознавания текста...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicializando el motor OCR...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在初始化OCR引擎……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCRエンジンを初期化しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("OCR इंजन प्रारंभ हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inicializando o mecanismo de OCR...")
	return /** @type {LocalizedString} */ ("Initializing OCR engine...")
});